
export const Language = {
  languageOptions: [{ label: 'all', value: 'all', active: true },
    { label: 'zh_cn', value: 'zh_cn', active: true },
    { label: 'zh_tw', value: 'zh_tw', active: true },
    { label: 'en', value: 'en', active: true },
    { label: 'ko', value: 'ko', active: true },
    { label: 'de', value: 'de', active: true },
    { label: 'fr', value: 'fr', active: false },
    { label: 'it', value: 'it', active: false },
    { label: 'es', value: 'es', active: false },
    { label: 'ar', value: 'ar', active: false },
    { label: 'ru', value: 'ru', active: false },
    { label: 'nl', value: 'nl', active: false },
    { label: 'pt', value: 'pt', active: false },
    { label: 'pl', value: 'pl', active: false },
    { label: 'th', value: 'th', active: false },
    { label: 'cs', value: 'cs', active: false },
    { label: 'sk', value: 'sk', active: false },
    { label: 'el', value: 'el', active: false },
    { label: 'hu', value: 'hu', active: false },
    { label: 'bg', value: 'bg', active: false },
    { label: 'tr', value: 'tr', active: false },
    { label: 'ro', value: 'ro', active: false }],
  i18nKey: 'languageT',
  zhCn: {
    languageT: {
      all: '所有语言',
      // eslint-disable-next-line @typescript-eslint/camelcase
      zh_cn: '中文简体',
      // eslint-disable-next-line @typescript-eslint/camelcase
      zh_tw: '中文繁体',
      en: '英语',
      ja: '日语',
      ko: '韩语',
      de: '德语',
      fr: '法语',
      it: '意大利语',
      es: '西班牙语',
      ar: '阿拉伯语',
      ru: '俄语',
      nl: '荷兰语',
      pt: '葡萄牙语',
      pl: '波兰语',
      th: '泰语',
      cs: '捷克语',
      sk: '斯洛伐克语',
      el: '希腊语',
      hu: '匈牙利语',
      bg: '保加利亚语',
      tr: '土耳其语',
      ro: '罗马尼亚语'
    }
  },
  en: {
    languageT: {
      all: '所有语言',
      // eslint-disable-next-line @typescript-eslint/camelcase
      zh_cn: '中文简体',
      // eslint-disable-next-line @typescript-eslint/camelcase
      zh_tw: '中文繁体',
      en: '英语',
      ja: '日语',
      ko: '韩语',
      de: '德语',
      fr: '法语',
      it: '意大利语',
      es: '西班牙语',
      ar: '阿拉伯语',
      ru: '俄语',
      nl: '荷兰语',
      pt: '葡萄牙语',
      pl: '波兰语',
      th: '泰语',
      cs: '捷克语',
      sk: '斯洛伐克语',
      el: '希腊语',
      hu: '匈牙利语',
      bg: '保加利亚语',
      tr: '土耳其语',
      ro: '罗马尼亚语'
    }
  }
}
